<template>
  <!-- @mouseleave="mouseleave" -->
  <div class="navlink"
    :class="{ menu, dark, border }"
    @mouseenter="mouseenter">
    <span ref="span">{{ text }}</span>
  </div>
</template>

<script>
import { TweenMax, TimelineMax, Power2 } from 'gsap/TweenMax'
import SplitText from '@/assets/lib/gsap-bonus/SplitText'

export default {
  props: {
    text: String,
    menu: Boolean,
    dark: Boolean,
    border: Boolean
  },

  beforeDestroy () {
    this.tlText && this.tlText.kill()
    this.tlText = null
    this.mySplitText = null
    this.chars = null
    this.isPlaying = null
  },

  mounted () {
    this.isPlaying = false

    this.mySplitText = new SplitText(this.$refs.span, {
      type: 'chars'
    })

    this.chars = this.mySplitText.chars

    this.initTimelineText()
  },

  methods: {
    letterCompleteAll () {
      this.isPlaying = false
    },

    letterComplete (e, t) {
      this.isPlaying = true
      TweenMax.set(e.target, {
        y: -5
      })
      TweenMax.to(e.target, 0.25, {
        opacity: 1,
        y: 0,
        delay: t,
        ease: Power2.easeOut
      }, 0.02)
    },

    initTimelineText () {
      this.tlText = new TimelineMax({
        paused: !0,
        onComplete: this.letterCompleteAll
      }).staggerTo(this.chars, 0.25, {
        opacity: 0,
        y: 5,
        ease: Power2.easeOut,
        onComplete: this.letterComplete,
        onCompleteParams: ['{self}', 0]
      }, 0.02)
    },

    mouseenter () {
      // console.log('mouseenter')
      !this.isPlaying && this.tlText.restart()
    }
  }
}
</script>

<style lang="scss" scoped>
.navlink {
  color: #fff;
  width: 170px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  transition: color 0.8s ease-in-out;
  // pointer-events: none;
}
@media(max-width: 1366px){
  .navlink{
    font-size: 14px;
  }
}
.navlink.menu {
  color: #85a8be;
}

.navlink.dark {
  color: #000;
}

.navlink.border {
  color: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  transition: color 0.8s ease-in-out, border-color 0.8s ease-in-out;
}
.navlink.border.dark {
  color: #000;
  border-color: #000;
}

.navlink span, .navlink span div{
  pointer-events: none;
}
</style>
